import AxiosWrapper from "../../basecomp/base/AxiosWrapper"
import { fetchData } from "../apis/apis"


export async function PendingTicketsApi(url) {
//      let response = await AxiosWrapper.axiosGetCallWithToken(url,new FormData())
        let response= fetchData(url,new FormData())

        // console.log(response.ticket_data);
        // console.log(response.totalcount);
        return response
}

export async function CompletedTicketsApi(url) {
        // "/ticket-tool/getcompletedtickets"
        let response= fetchData(url,new FormData())

// //      let response = await AxiosWrapper.axiosGetCallWithToken(url,new FormData())
        
        return response
}
export async function AssignedTicketsApi(url) {
        let response= fetchData(url,new FormData())

//      let response = await AxiosWrapper.axiosGetCallWithToken(url,new FormData())
        
        return response
}